import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorUpdates = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M5.75 3a.75.75 0 0 0-1.5 0v4c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5H6.084A8.25 8.25 0 0 1 20.25 12a.75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75a9.713 9.713 0 0 0-6.25 2.266V3Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M3.75 12a.75.75 0 0 0-1.5 0c0 5.385 4.365 9.75 9.75 9.75a9.719 9.719 0 0 0 6.75-2.714V21a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0 0 1.5h2.416A8.25 8.25 0 0 1 3.75 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorUpdates;
